<template>
  <div class="ts-app-shell_fh">
    <div class="ts-app-landing-dashboard">
      <div class="padd-main ts-wioa">
        <el-row class="narrow">
          <el-col>
            <h5 class="dashboard-title">WIOA Status</h5>
          </el-col>
        </el-row>
        <el-row class="narrow">
          <el-col class="dashboard-paragraph">
            <span style="font-size: 12px;">Review the status of your WIOA application.</span>
          </el-col>
        </el-row>
        <el-divider></el-divider>
        <el-row container :gutter="24">
          <el-col :xs="16" :md="16" :lg="16">
            <h6>Date of Application: {{dateOfApplication | moment("MMMM DD, YYYY")}} </h6>
          </el-col>
          <el-col :xs="8" :md="8" :lg="8">
            <el-button class="btn-details ts-btn-secondary wide" style="margin-top: 0px !important" @click="goToWioaDashboard">
              Back
            </el-button>
          </el-col>
        </el-row>
        <el-row class="min-spacing">
          <el-col :xs="24" :md="24" :lg="24">
            <h6>Status:</h6>
          </el-col>
        </el-row>
        <el-row class="min-spacing">
          <el-col :xs="24" :md="24" :lg="24">
            <span :class="status == 'FORREVIEW' || status == 'FORAPPROVAL' || status == 'FORREVOKE' ? 'current-status': 'default-status'">In Review</span>
          </el-col>
        </el-row>
        <el-row class="min-spacing">
          <el-col :xs="24" :md="24" :lg="24">
            <span :class="status == 'PENDING' ? 'current-status': 'default-status'">Pending</span>
          </el-col>
        </el-row>
        <el-row class="min-spacing">
          <el-col :xs="24" :md="24" :lg="24">
            <span :class="status == 'COMPLETED' ? 'current-status': 'default-status'">Approved</span>
          </el-col>
        </el-row>
        <el-row class="min-spacing">
          <el-col :xs="24" :md="24" :lg="24">
            <span :class="status == 'REVOKED' ? 'current-status': 'default-status'">Rejected</span>
          </el-col>
        </el-row>

        <div v-if="status == 'FORREVIEW' || status == 'FORAPPROVAL' || status == 'FORREVOKE'">
          <el-row class="min-spacing">
            <el-col :xs="24" :md="24" :lg="24">
              <h6>In Review</h6>
            </el-col>
            <el-col :xs="24" :md="24" :lg="24" style="margin-top: 20px;">
              <span style="font-size: 12px;">Your application is being reviewed by a designated staff member. Keep coming back to check the status of your update!</span>
            </el-col>
          </el-row>
          <div class="checklist-info-box">
            <el-row>
              <el-col :xs="24" :md="24" :lg="24">
                <h6>Your WIOA Eligibility checklist is currently being reviewed by our team!</h6>
              </el-col>
            </el-row>
            <el-row>
              <el-col :xs="24" :md="24" :lg="24">
                <span style="font-size: 12px;">You can still view your responses from your completed WIOA Checklist</span>
              </el-col>
            </el-row>
            <el-row>
              <el-button class="btn-details ts-btn-secondary wide" @click="gotoViewChecklist">
                View Checklist
              </el-button>
            </el-row>
          </div>
        </div>

        <div v-if="status == 'PENDING'">
          <el-row class="min-spacing">
            <el-col :xs="24" :md="24" :lg="24">
              <h6>Pending</h6>
            </el-col>
            <el-col :xs="24" :md="24" :lg="24" style="margin-top: 20px;">
              <span style="font-size: 12px;">Your application has been marked as pending - view the notes of designated staff members</span>
            </el-col>
          </el-row>
          <div class="checklist-info-box">
            <el-row class="min-spacing" style="margin-bottom: 0px !important; margin-top: 10px !important">
              <el-col :xs="20" :md="20" :lg="20">
                <h6>Designated Staff Members Notes</h6>
              </el-col>
              <el-col :xs="4" :md="4" :lg="4">
                <img src="../../../assets/img/wioa-question-mark.png" style="margin-top: -60px;">
              </el-col>
            </el-row>
            <el-row class="min-spacing">
              <el-input
                type="textarea"
                v-model="notes"
                rows="8"
                placeholder="Notes"
                style="width: 500px;"
              />
            </el-row>
            <el-row class="min-spacing">
              <el-button class="btn-details ts-btn-secondary wide" @click="gotoEditChecklist">
                View/Edit Checklist
              </el-button>
            </el-row>
          </div>
        </div>

        <div v-if="status == 'COMPLETED'">
          <el-row class="min-spacing">
            <el-col :xs="24" :md="24" :lg="24">
              <h6>Approved</h6>
            </el-col>
            <el-col :xs="24" :md="24" :lg="24" style="margin-top: 20px;">
              <span style="font-size: 12px;">Your application is complete! A designated staff member will be in contact with you regarding the next steps!</span>
            </el-col>
          </el-row>
          <div class="checklist-info-box">
            <el-row>
              <el-col :xs="20" :md="20" :lg="20">
                <h6>Your WIOA Eligibility Checklist has been marked as approved!</h6>
              </el-col>
              <el-col :xs="4" :md="4" :lg="4">
                <img src="../../../assets/img/wioa-check.png" style="margin-top: -10px;">
              </el-col>
            </el-row>
            <el-row>
              <el-col :xs="24" :md="24" :lg="24">
                <span style="font-size: 12px;">A designated staff member will be in contact regarding next steps.</span>
              </el-col>
            </el-row>
            <el-row>
              <el-button class="btn-details ts-btn-secondary wide" @click="goToWioaDashboard">
                Home
              </el-button>
            </el-row>
          </div>
        </div>

        <div v-if="status == 'REVOKED'">
          <el-row class="min-spacing">
            <el-col :xs="24" :md="24" :lg="24">
              <h6>Rejected</h6>
            </el-col>
            <el-col :xs="24" :md="24" :lg="24" style="margin-top: 20px;">
              <span style="font-size: 12px;">Your WIOA application has been rejected!</span>
            </el-col>
          </el-row>
          <div class="checklist-info-box">
            <el-row>
              <el-col :xs="20" :md="20" :lg="20">
                <h6>Your WIOA Eligibility Checklist has been marked as rejected!</h6>
              </el-col>
              <el-col :xs="4" :md="4" :lg="4" style="text-align: center;">
                <img src="../../../assets/img/wioa-cancel.png" style="margin-top: -10px;">
              </el-col>
            </el-row>
            <el-row>
              <el-col :xs="24" :md="24" :lg="24">
                <span style="font-size: 12px;">Please contact your case manager if you have any questions regarding your application.</span>
              </el-col>
            </el-row>
            <el-row>
              <el-button class="btn-details ts-btn-secondary wide" @click="goToWioaDashboard">
                Home
              </el-button>
            </el-row>
          </div>
        </div>
        <br/><br/><br/>
      </div>
    </div>
    <TSLoading
      :active="loading"
      :defaultMessage="'Please wait...'"
      :altMessage="'Please hold on for a moment while we process your data...'"
    />
  </div>
</template>

<script>
import TSLoading from "../../../components/TSLoading.vue";

export default {
  components: { TSLoading },
  data(){
    return{
      loading: false,
      dateOfApplication: null,
      checklistId: null,
      status: null,
      notes: null
    }
  },
  computed: {
    currentUser() {
      debugger;
      return this.$store.state.account.current_user;
    },
  },
  created(){
    debugger;
    this.loading = true;
      this.$store.dispatch("wioa/getCheckliStstatusByClient", this.currentUser.id).then((res) => {
        debugger;
        this.dateOfApplication = res.dateOfApplication;
        this.status = res.checklistStatus;
        this.checklistId = res.checklistId;
        this.notes = res.notes;
      })
      .finally(() => {
        this.loading = false;
      });
  },
  methods: {
    goToWioaDashboard(){
      this.$router.push({ name: "WioaDashboard" });
    },
    gotoViewChecklist(){
      debugger;
      this.$router.push({ name: "ViewChecklist", params: {checklistId: this.checklistId} });
    },
    gotoEditChecklist(){
      localStorage.setItem('editChecklist', this.checklistId);
      this.$router.push({ name: "WioaChecklist" });
    },
  }
};
</script>

<style lang="scss" scoped>

.wide {
  width: 250px;
  margin-top: 10px;
  color: white;
}

.min-spacing
{
  margin-bottom: 20px;;
}

.default-status
{
  font-size: 15px;
  color: lightgray;
}

.current-status
{
  font-size: 15px;
  color: black;  
  font-weight: bold;
}

.checklist-info-box
{
  padding: 20px;
  border: 1px solid #DFDFDF;
  width: 700px;
  border-radius: 5px;
  box-shadow: 2px 2px #00000029;
}
</style>